import React, { useState, useEffect } from "react";
import global from "../../global-variables";
import Header from "../layout/header";
import { Link } from "react-router-dom";
import $ from "jquery";
import WOW from "wowjs";
import { Container, Row, Col } from "reactstrap";
import { FaLongArrowAltRight } from "react-icons/fa";
import Breadcrumb from 'react-bootstrap/Breadcrumb';

import Metatag from "../../hooks/Metatag";

export default function Milestone() {
    const [toggler, setToggler] = useState(true);
    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
    };

    useEffect(() => {
        // add class for home header and remove inner class
        $(".fixed-top").addClass("bg-header");

        // initiate the wow effect
        new WOW.WOW({
            live: false,
        }).init();

        // hotspot

        var $hotspots;

        function init() {
            $hotspots = $('.map-hotspot-icon');
            $('.hs-close').add($hotspots).click(togglePanel);
        }

        function togglePanel(e) {
            //close previously open
            $('.map-hotspot.active').find('.map-reveal').hide();
            var $hotspot = $(e.target).closest('.map-hotspot'),
                $icon = $hotspot.find('.map-hotspot-icon'),
                $panel = $icon.siblings('.map-reveal');
            $('.map-hotspot.active').not($hotspot).removeClass('active');
            $panel.show(function () { });
            $hotspot.toggleClass('active');

            if (!$hotspot.hasClass('active')) {
                $panel.hide();
            }
        }
        $(init);



    }, []);

    return (
        <>
            <Header main_className="bg-header"></Header>
            {/* Metatag  */}
            <Metatag title='National Disease Modelling Consortium Milestones'  
                    keywords='The National Disease Modelling Consortium Milestones, NDMC Milestones' 
                    description='National Disease Modelling Consortium Milestones'
                    />

            <Container fluid className="px-0 bg-visual position-relative" style={{ backgroundImage: "url('./images/bg-milestones.jpg')", backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center" }}>
                <img src={global.variables.strDomainUrl + "images/bg-blank.png"} alt="" title="" className="w-100" />
                <div className="masthead d-flex align-items-center w-100">
                    <Container className="px-4 px-md-5">
                        <h1 className="mb-0 fw-bold text-white text-uppercase pb-xl-5 py-4">Milestones</h1>
                    </Container>
                </div>
            </Container>

            <Container className="content-bg bordr bg-white rounded-3 shadow-sm">

                <section id="cd-timeline" class="cd-container">

                    <div class="cd-timeline-block">
                        <div class="cd-timeline-img cd-movie">
                        </div>
                        <div class="cd-timeline-content">
                            <p class="m-0">Second TB DSAG Meeting</p>
                            <p class="m-0">Second Malaria DSAG Meeting</p>
                            <span class="cd-date">Nov 2024</span>
                        </div>
                    </div>

                    <div class="cd-timeline-block">
                        <div class="cd-timeline-img cd-movie">
                        </div>
                        <div class="cd-timeline-content">
                            <p class="m-0">Second NTD DSAG Meeting</p>
                            <p class="m-0">Second VPD DSAG Meeting</p>
                            <span class="cd-date">Oct 2024</span>
                        </div>
                    </div>

                    <div class="cd-timeline-block">
                        <div class="cd-timeline-img cd-movie">
                        </div>
                        <div class="cd-timeline-content">
                            <p class="m-0">MoU between MoHFW and NDMC</p>
                            <span class="cd-date">July 2024</span>
                        </div>
                    </div>

                    <div class="cd-timeline-block">
                        <div class="cd-timeline-img cd-movie">
                        </div>
                        <div class="cd-timeline-content">
                            <p class="m-0">First Malaria DSAG Meeting</p>
                            <span class="cd-date">May 2024</span>
                        </div>
                    </div>

                    <div class="cd-timeline-block">
                        <div class="cd-timeline-img cd-movie">
                        </div>
                        <div class="cd-timeline-content">
                            <p class="m-0">Second Advisory Council Meeting First TB DSAG Meeting</p>
                            <span class="cd-date">April 2024</span>
                        </div>
                    </div>

                    <div class="cd-timeline-block">
                        <div class="cd-timeline-img cd-movie">
                        </div>
                        <div class="cd-timeline-content">
                            <p class="m-0">First NTD-DSAG Meeting</p>
                            <span class="cd-date">March 2024</span>
                        </div>
                    </div>

                    <div class="cd-timeline-block">
                        <div class="cd-timeline-img cd-movie">
                        </div>
                        <div class="cd-timeline-content">
                            <p class="m-0">First VPD-DSAG Meeting</p>
                            <span class="cd-date">February 2024</span>
                        </div>
                    </div>

                    <div class="cd-timeline-block">
                        <div class="cd-timeline-img cd-movie">
                        </div>
                        <div class="cd-timeline-content">
                            <p class="m-0">First Advisory Council Meeting</p>
                            <span class="cd-date">April 2023</span>
                        </div>
                    </div>

                    <div class="cd-timeline-block">
                        <div class="cd-timeline-img cd-movie">
                        </div>
                        <div class="cd-timeline-content">
                            <p class="m-0">Workshop on Health Analytics and Disease Modelling, IIT Bombay </p>
                            <Link to={global.variables.strDomainUrl + "events-detail/workshop-on-health-analytics-and-disease-modelling"}>
                                <span class="btn btn-slide rounded-pill px-3 mb-2 mt-3">
                                    Read More<FaLongArrowAltRight className="ms-2" />
                                </span>
                            </Link>
                            <span class="cd-date">February 2023</span>
                        </div>
                    </div>

                    <div class="cd-timeline-block">
                        <div class="cd-timeline-img cd-picture">
                        </div>

                        <div class="cd-timeline-content">
                            <p class="m-0">
                                Acceptance of DIMAG as the National Disease Modelling Consortium
                                (NDMC) and acceptance of Chairperson of the Advisory Council
                            </p>
                            <span class="cd-date">December 2022</span>
                        </div>
                    </div>

                    <div class="cd-timeline-block">
                        <div class="cd-timeline-img cd-location">
                        </div>

                        <div class="cd-timeline-content">
                            <p class="m-0">Advisory council for DIMAG identified</p>
                            <span class="cd-date">November 2022</span>
                        </div>
                    </div>

                    <div class="cd-timeline-block">
                        <div class="cd-timeline-img cd-location">
                        </div>
                        <div class="cd-timeline-content">
                            <p class="m-0">
                                IIT Bombay awarded seed funding for the Disease and Interventions
                                Modelling to Action Group (DIMAG)
                            </p>
                            <span class="cd-date">October 2022</span>
                        </div>
                    </div>
                </section>

            </Container >


            {/* Breadcrumb */}
            <Container Container fluid className="small pt-3 p-0 bg-white d-flex justify-content-center mt-auto" >
                <Breadcrumb>
                    <Breadcrumb.Item href={global.variables.strDomainUrl}>Home</Breadcrumb.Item>
                    <Breadcrumb.Item active>About Us</Breadcrumb.Item>
                    <Breadcrumb.Item active>Milestones</Breadcrumb.Item>
                </Breadcrumb>
            </Container>
            {/* Breadcrumb */}
        </>
    );
}